export default __webpack_public_path__ + "static/media/03e_folded.bdf80924.png";